export default (timestamp: number | Date, dayOfMonth: number): Date => {
    const date = new Date(+timestamp);
    date.setUTCDate(dayOfMonth);
    return date;
};
